import { createSlice } from "@reduxjs/toolkit";

export const areaSelectedSlice = createSlice({
    name: 'areaselected',
    initialState: {
        level: 1,
        value: "thailand",
        bbox: [],
        prov_list: undefined
    },
    reducers: {
        setAreaSelected: (state, action) => {
            state.level = action.payload.level;
            state.value = action.payload.value;
            state.bbox = action.payload.bbox;
            state.prov_list = action.payload.prov_list;
        }
    }
})

export const { setAreaSelected } = areaSelectedSlice.actions;

export const getAreaSelected = (state) => state.areaselected;

export default areaSelectedSlice.reducer;